import React, { forwardRef } from 'react';
import './Input.scss';

const cx = (...classes) => classes.filter(Boolean).join(' ');

const Input = forwardRef(({
  size = 'md',
  invalid = false,
  fullWidth = true,
  leftIcon,
  rightIcon,
  className = '',
  inputClassName = '',
  disabled,
  ...props
}, ref) => (
  <span
    className={cx(
      'reops-input',
      `reops-input--${size}`,
      invalid && 'is-invalid',
      disabled && 'is-disabled',
      fullWidth && 'reops-input--full',
      className,
    )}
  >
    {leftIcon ? <span className="reops-input__icon" aria-hidden="true">{leftIcon}</span> : null}
    <input
      ref={ref}
      className={cx('reops-input__control', inputClassName)}
      disabled={disabled}
      {...props}
    />
    {rightIcon ? <span className="reops-input__icon" aria-hidden="true">{rightIcon}</span> : null}
  </span>
));

Input.displayName = 'Input';

export default Input;
